import { render, staticRenderFns } from "./PriceChange.vue?vue&type=template&id=8bc59288&scoped=true"
import script from "./PriceChange.vue?vue&type=script&lang=js"
export * from "./PriceChange.vue?vue&type=script&lang=js"
import style0 from "./PriceChange.vue?vue&type=style&index=0&id=8bc59288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc59288",
  null
  
)

export default component.exports